export default {
  name: 'marking--confirmDocType',
};